import React from "react";
import { Redirect } from "react-router";

const Frontpage = () => {
  return <Redirect to="/position/" />;
};

export default Frontpage;
